'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _FormattedDateTime = require('I18n/components/FormattedDateTime');

var _FormattedDateTime2 = _interopRequireDefault(_FormattedDateTime);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _SenderTypePropType = require('../prop-types/SenderTypePropType');

var _SenderTypePropType2 = _interopRequireDefault(_SenderTypePropType);

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _isUnpublished = require('conversations-schema/pubnub-message/operators/isUnpublished');

var _isPublishFailed = require('conversations-schema/pubnub-message/operators/isPublishFailed');

var _pubnubMessageGetters = require('conversations-schema/pubnub-message/operators/pubnubMessageGetters');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _isFromAgent = require('conversations-schema/pubnub-message/operators/isFromAgent');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _QuickReplyGroup = require('./QuickReplyGroup');

var _QuickReplyGroup2 = _interopRequireDefault(_QuickReplyGroup);

var _SenderName = require('./SenderName');

var _SenderName2 = _interopRequireDefault(_SenderName);

var _WelcomeMessageTooltip = require('./WelcomeMessageTooltip');

var _WelcomeMessageTooltip2 = _interopRequireDefault(_WelcomeMessageTooltip);

var _shouldDisplayAsSent = require('conversations-schema/chat-message/operators/shouldDisplayAsSent');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageFooter = _react2.default.createClass({
  displayName: 'MessageFooter',

  propTypes: {
    className: _react.PropTypes.string,
    coloring: (0, _RecordPropType2.default)('ColoringRecord'),
    currentRole: _SenderTypePropType2.default.isRequired,
    hideLabels: _react.PropTypes.bool,
    isLastInGroup: _react.PropTypes.bool,
    message: (0, _RecordPropType2.default)('PubNubMessageRecord').isRequired,
    messageRole: _SenderTypePropType2.default.isRequired,
    nextMessage: (0, _RecordPropType2.default)('PubNubMessageRecord'),
    publishMessage: _react.PropTypes.func,
    quickReplyDisabled: _react.PropTypes.bool,
    republishMessage: _react.PropTypes.func,
    responder: _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('Responder'), (0, _RecordPropType2.default)('Visitor')]),
    showFooterContent: _react.PropTypes.bool
  },

  mixins: [_react2.default.addons.PureRenderMixin],

  currentRoleIsVisitor: function currentRoleIsVisitor() {
    return this.props.currentRole === _senderTypes.VISITOR;
  },
  isAgentMessageInInbox: function isAgentMessageInInbox() {
    return this.props.messageRole === _senderTypes.AGENT && this.props.currentRole === _senderTypes.AGENT;
  },
  hasQuickReplyOptions: function hasQuickReplyOptions() {
    var _props = this.props,
        message = _props.message,
        messageRole = _props.messageRole,
        currentRole = _props.currentRole;


    return (0, _pubnubMessageGetters.getQuickReply)(message) && messageRole === _senderTypes.BOT && currentRole === _senderTypes.VISITOR;
  },
  hasBeenAnswered: function hasBeenAnswered() {
    var _props2 = this.props,
        message = _props2.message,
        nextMessage = _props2.nextMessage;


    var hasQuickReplyResponse = nextMessage && (0, _pubnubMessageGetters.getQuickReply)(nextMessage);

    var allowUserInput = (0, _pubnubMessageGetters.getAllowUserInput)(message);

    return nextMessage && (hasQuickReplyResponse || allowUserInput || (0, _isFromAgent.isFromAgent)(nextMessage));
  },
  shouldRenderQuickReply: function shouldRenderQuickReply() {
    return this.hasQuickReplyOptions() && !this.hasBeenAnswered();
  },
  shouldHideFooter: function shouldHideFooter() {
    var _props3 = this.props,
        message = _props3.message,
        isLastInGroup = _props3.isLastInGroup,
        showFooterContent = _props3.showFooterContent,
        hideLabels = _props3.hideLabels;


    if (hideLabels) {
      return true;
    }

    if (this.shouldRenderQuickReply()) {
      return false;
    }

    return !isLastInGroup && (0, _shouldDisplayAsSent.shouldDisplayAsSent)(message) || !showFooterContent;
  },
  handleQuickReplySend: function handleQuickReplySend(text, options) {
    var _props4 = this.props,
        message = _props4.message,
        publishMessage = _props4.publishMessage;


    var quickReply = (0, _pubnubMessageGetters.getQuickReply)(message);
    var updatedQuickReply = quickReply.set('quickReplies', options.toJS());

    publishMessage({
      text: text,
      quickReply: updatedQuickReply
    });
  },
  renderFailedMessage: function renderFailedMessage() {
    var _props5 = this.props,
        message = _props5.message,
        republishMessage = _props5.republishMessage;


    var onClick = function onClick() {
      return republishMessage(message);
    };

    return _react2.default.createElement(
      _Small2.default,
      { use: 'error' },
      _react2.default.createElement(
        _UILink2.default,
        { use: 'danger', onClick: onClick },
        _react2.default.createElement(_FormattedHTMLMessage2.default, {
          message: 'conversationsUI.chat.status.' + (0, _pubnubMessageGetters.getStatus)(message)
        })
      )
    );
  },
  renderStatus: function renderStatus() {
    var _props6 = this.props,
        message = _props6.message,
        currentRole = _props6.currentRole;

    var timestamp = (0, _messageTypeComparators.isInitialMessage)(message) ? (0, _commonMessageFormatGetters.getClientTs)(message) : (0, _commonMessageFormatGetters.getTimestamp)(message);
    var className = currentRole === _senderTypes.VISITOR ? 'chat-message-visitor-timestamp' : 'chat-message-inbox-timestamp';

    switch (true) {
      case (0, _shouldDisplayAsSent.shouldDisplayAsSent)(message):
        return _react2.default.createElement(
          'span',
          { className: className },
          _react2.default.createElement(_FormattedDateTime2.default, { value: timestamp, format: 'LT', type: 'userTz' })
        );

      case (0, _isUnpublished.isUnpublished)(message):
        return _react2.default.createElement(_FormattedHTMLMessage2.default, {
          message: 'conversationsUI.chat.status.UNPUBLISHED'
        });

      case (0, _isPublishFailed.isPublishFailed)(message):
        return this.renderFailedMessage();

      default:
        return null;
    }
  },
  renderQuickReplyGroup: function renderQuickReplyGroup() {
    var _props7 = this.props,
        metadata = _props7.message.metadata,
        coloring = _props7.coloring,
        quickReplyDisabled = _props7.quickReplyDisabled;
    var _metadata$quickReply = metadata.quickReply,
        quickReplies = _metadata$quickReply.quickReplies,
        allowMultiSelect = _metadata$quickReply.allowMultiSelect;


    return _react2.default.createElement(_QuickReplyGroup2.default, {
      options: quickReplies,
      multiSelect: allowMultiSelect,
      hasSentReply: false,
      coloring: coloring,
      onSend: this.handleQuickReplySend,
      disabled: quickReplyDisabled
    });
  },
  renderSenderText: function renderSenderText() {
    var _props8 = this.props,
        currentRole = _props8.currentRole,
        messageRole = _props8.messageRole,
        responder = _props8.responder,
        message = _props8.message;


    if ((0, _messageTypeComparators.isAutomatedChatMessage)(message)) {
      return null;
    }

    if ((0, _messageTypeComparators.isInitialMessage)(message) && currentRole === _senderTypes.AGENT) {
      return _react2.default.createElement(_WelcomeMessageTooltip2.default, null);
    }

    if (!responder || this.isAgentMessageInInbox()) {
      return null;
    }

    return _react2.default.createElement(_SenderName2.default, {
      currentRole: currentRole,
      messageRole: messageRole,
      responder: responder
    });
  },
  renderContent: function renderContent() {
    var message = this.props.message;

    /**
     * If you move this block you will break quick replies for initial bot messages!
     *
     * See https://git.hubteam.com/HubSpot/conversations-team/issues/313
     */

    if (this.shouldRenderQuickReply()) {
      return this.renderQuickReplyGroup();
    }

    if ((0, _messageTypeComparators.isInitialMessage)(message) && this.currentRoleIsVisitor()) {
      return null;
    }

    return _react2.default.createElement(
      'span',
      null,
      this.renderSenderText(),
      this.renderStatus()
    );
  },
  render: function render() {
    var _props9 = this.props,
        className = _props9.className,
        messageRole = _props9.messageRole,
        currentRole = _props9.currentRole;


    if (this.shouldHideFooter()) {
      return null;
    }

    var classes = (0, _classNames2.default)(className, 'chat-message-name', {
      'text-right p-right-1': messageRole === currentRole,
      'text-left': messageRole !== currentRole
    });

    return _react2.default.createElement(
      _Small2.default,
      { className: classes },
      this.renderContent()
    );
  }
});

exports.default = MessageFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/MessageFooter.js
// module id = 543
// module chunks = 2 3